import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
// Tailwind css
import './tailwind.css';

// i18n (needs to be bundled)
import './i18n';

// Router
import { RouterProvider } from 'react-router-dom';
import router from './router/index';

// AXIOS (AXIOS & INTERCEPTORS)
import './lib/axios/axios-global';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// GTM
import { initGTM } from './utils/gtm';

// SEO
import { HelmetProvider } from 'react-helmet-async';

const queryClient = new QueryClient();

// Initialize GTM
initGTM();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <HelmetProvider>
        <Suspense>
            <QueryClientProvider client={queryClient}>
                <RouterProvider router={router} />
            </QueryClientProvider>
        </Suspense>
    </HelmetProvider>,
);
